import moment from 'moment';

export default {
    data: {
        formData: null,
    },
    objectToFormData(obj, rootName, ignoreList) {
        this.formData = new FormData();
        this.appendFormData(obj, rootName);

        return this.formData;
    },
    appendFormData(data, root) {
        root = root || '';
        if (data instanceof File) {
            this.formData.append(root, data);
        } else if (Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                this.appendFormData(data[i], root + '[' + i + ']');
            }
        } else if (typeof data === 'object' && data) {
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    if (root === '') {
                        this.appendFormData(data[key], key);
                    } else {
                        this.appendFormData(data[key], root + '.' + key);
                    }
                }
            }
        } else {
            if (data !== null && typeof data !== 'undefined') {
                this.formData.append(root, data);
            }
        }
    },
    tableLabels() {
        return {
            count: "Mostrando desde {from} a {to} de {count} registros|{count} registros|1 registro",
            filterPlaceholder: "Buscar",
            filter: "Filtro",
            first: 'Primero',
            last: 'Último',
            limit: "Registros",
            page: "Página:",
            noResults: "Sin registros coincidentes",
            filterBy: "Filtro por {column}",
            loading: 'Cargando...',
            defaultOption: 'Seleccionar {column}',
            columns: 'Columna'
        }
    },
    parser(data, property, type) {

        if (data === undefined) {
            if (type == 'string') {
                return ''
            } else {
                return 0
            }
        } else {
            return data[property]
        }
    },
    generateIBAN(ccc) {
        var iban = null;

        if (ccc.length == 20) {
            iban =  98 - this.modulo((ccc + '142800'), 97);

            if (iban > 9) {
                iban = 'ES' + iban;
            } else {
                iban = 'ES0' + iban;
            }
        }

        return iban;
    },
    checkIBAN(iban) {
        if (iban.length == 24) {
            var digitoControl = this.getCodigoControl_IBAN(iban.substr(0, 2), iban.substr(4));
            if (digitoControl == iban.substr(2, 2))
                return true;
        }
        return false;
    },
    /**
     * Funcion que devuelve el codigo de verificacion de una cuenta bancaria
     * @param string codigoPais los dos primeros caracteres del IBAN
     * @param string cc la cuenta corriente, que son los ultimos 20 caracteres del IBAN
     * @return string devuelve el codigo de control
     */
    getCodigoControl_IBAN(codigoPais, cc) {
        // cada letra de pais tiene un valor
        var valoresPaises = {
            'A': '10',
            'B': '11',
            'C': '12',
            'D': '13',
            'E': '14',
            'F': '15',
            'G': '16',
            'H': '17',
            'I': '18',
            'J': '19',
            'K': '20',
            'L': '21',
            'M': '22',
            'N': '23',
            'O': '24',
            'P': '25',
            'Q': '26',
            'R': '27',
            'S': '28',
            'T': '29',
            'U': '30',
            'V': '31',
            'W': '32',
            'X': '33',
            'Y': '34',
            'Z': '35'
        };

        // reemplazamos cada letra por su valor numerico y ponemos los valores mas dos ceros al final de la cuenta
        var dividendo = cc + valoresPaises[codigoPais.substr(0, 1)] + valoresPaises[codigoPais.substr(1, 1)] + '00';

        // Calculamos el modulo 97 sobre el valor numerico y lo restamos al valor 98
        var digitoControl = 98 - this.modulo(dividendo, 97);

        // Si el digito de control es un solo numero, añadimos un cero al delante
        if (digitoControl.length == 1) {
            digitoControl = '0' + digitoControl;
        }
        return digitoControl;
    },
    /**
     * Funcion para calcular el modulo
     * @param string valor
     * @param integer divisor
     * @return integer
     */
    modulo(valor, divisor) {
        var resto = 0;
        var dividendo = 0;
        for (var i = 0; i < valor.length; i += 10) {
            dividendo = resto + "" + valor.substr(i, 10);
            resto = dividendo % divisor;
        }
        return resto;
    },
    validateNIF(value) {
        if (!value) {
            return false
        }
        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
        var nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var str = value.toString().toUpperCase();

        if (!nifRexp.test(str) && !nieRexp.test(str)) return false;
        var nie = str
            .replace(/^[X]/, '0')
            .replace(/^[Y]/, '1')
            .replace(/^[Z]/, '2');

        var letter = str.substr(-1);
        var charIndex = parseInt(nie.substr(0, 8)) % 23;

        if (validChars.charAt(charIndex) === letter) return true;

        return false;
    },
    validateCIF(cif) {
        if (!cif) {
            return false
        }

        var CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
        var match = cif.match( CIF_REGEX );

        if (match == null) {
            return false;
        }

        var letter  = match[1],
            number  = match[2],
            control = match[3];

        var even_sum = 0;
        var odd_sum = 0;
        var n;

        for ( var i = 0; i < number.length; i++) {
            n = parseInt( number[i], 10 );

            if ( i % 2 === 0 ) {
                n *= 2;
                odd_sum += n < 10 ? n : n - 9;
            } else {
                even_sum += n;
            }
        }

        var control_digit = (10 - (even_sum + odd_sum).toString().substr(-1) );
        if (control_digit == 10) {
            control_digit = 0;
        }
        var control_letter = 'JABCDEFGHI'.substr( control_digit, 1 );
        var valid = false;

        if ( letter.match( /[ABEH]/ ) ) {
            valid = control == control_digit;
        } else if ( letter.match( /[KPQS]/ ) ) {
            valid =  control == control_letter;
        } else {
            valid =  control == control_digit || control == control_letter;
        }

        if (valid) {
            return cif;
        } else {
            return false;
        }
    },
    phone(value) {
        if (!value) {
            return false;
        }
        let phoneRegexp = /^[6789]{1}[0-9]{8}$/i;

        return phoneRegexp.test(value);
    },
    email(value) {
        let re = /\S+@\S+\.\S+/;
        return re.test(value);
    },
    validatePartnerBirthdate(value) {
        let age = moment().diff(moment(value, 'DD/MM/YYYY'), 'years');

        if (age < 18) {
            return false;
        }

        return true;
    },
    validateAutonomousRegisteredAt(value, birthday) {
        let formattedValue = moment(value, 'DD/MM/YYYY');
        let formattedBirthday = moment(birthday);
        let diff = formattedValue.diff(formattedBirthday, 'years');

        if (diff < 18) {
            return false;
        }

        return true;
    },
    validateRegisteredAt(value, autonomousRegisteredAt) {
        if(!autonomousRegisteredAt) return true;
        return !(moment(value, 'DD/MM/YYYY').isBefore(autonomousRegisteredAt));
    },
    validatePaidUntil(value, birthday) {
        return !(moment(value, 'DD/MM/YYYY').isBefore(birthday));
    },
}
